import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

const COLORES_NIVEL = {
  A1:'#22C55E', A2:'#3B82F6', B1:'#8B5CF6',
  B2:'#F59E0B', C1:'#EF4444', C2:'#1B3A8C'
}

const DIAS = ['Domingo','Lunes','Martes','Miercoles','Jueves','Viernes','Sabado']
const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']

function formatFecha(fechaStr, idioma = 'es') {
  const d = new Date(fechaStr + 'T00:00:00')
  if (idioma === 'en') return DIAS_EN[d.getDay()] + ', ' + MESES_EN[d.getMonth()] + ' ' + d.getDate()
  return DIAS[d.getDay()] + ' ' + d.getDate() + ' de ' + MESES[d.getMonth()]
}

const DIAS_EN = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
const MESES_EN = ['January','February','March','April','May','June','July','August','September','October','November','December']

// Las categorias vienen de la base de datos en espanol; se muestran traducidas en ingles.
const TEMAS_EN = {
  'general': 'General', 'Medio ambiente y tecnologia': 'Environment & technology', 'Viajes y turismo': 'Travel & tourism',
  'Arte y cultura': 'Art & culture', 'Gastronomia': 'Food & cuisine', 'Musica y entretenimiento': 'Music & entertainment',
  'Deportes': 'Sports', 'Ciencia y tecnologia': 'Science & technology', 'Historia y politica': 'History & politics'
}

const TX = {
  es: {
    errInscribir: 'Error al inscribirse', inscCancelada: 'Inscripcion cancelada', errCancelar: 'Error al cancelar',
    cargando: 'Cargando VideoForos...', volver: '← Volver a VideoForos', inscrito: 'Inscrito', categoria: 'Categoria:',
    fechaHora: 'Fecha y hora', duracion: 'Duracion:', minutos: 'minutos', termina: 'Termina:', moderador: 'Moderador',
    cuposDisp: 'Cupos disponibles', de: 'de', participantesMax: 'participantes max.', plataforma: 'Plataforma',
    videoconf: 'Video conferencia', unirse: '🎙 Unirse al VideoForo', cancelar: 'Cancelar', procesando: 'Procesando...',
    sinCuposLargo: 'Sin cupos disponibles', inscribirmeEste: 'Inscribirme al VideoForo', titulo: 'VideoForos',
    subtitulo: 'Reuniones virtuales en vivo sobre temas del mundo hispanohablante. Max. 10 participantes.',
    b1: 'Max. 10 personas', b2: 'Tema casual', b4: '75 minutos', todosNiveles: 'Todos los niveles',
    sesion: 'sesion', sesiones: 'sesiones', verDetalles: 'Ver detalles', sinCupos: 'Sin cupos', inscribirme: 'Inscribirme',
    vacio: 'No hay VideoForos disponibles para este nivel.'
  },
  en: {
    errInscribir: 'Could not enroll', inscCancelada: 'Enrollment cancelled', errCancelar: 'Could not cancel',
    cargando: 'Loading VideoForums...', volver: '← Back to VideoForums', inscrito: 'Enrolled', categoria: 'Category:',
    fechaHora: 'Date and time', duracion: 'Duration:', minutos: 'minutes', termina: 'Ends:', moderador: 'Moderator',
    cuposDisp: 'Available spots', de: 'of', participantesMax: 'participants max.', plataforma: 'Platform',
    videoconf: 'Video conference', unirse: '🎙 Join the VideoForum', cancelar: 'Cancel', procesando: 'Processing...',
    sinCuposLargo: 'No spots available', inscribirmeEste: 'Enroll in the VideoForum', titulo: 'VideoForums',
    subtitulo: 'Live virtual meetings about topics from the Spanish-speaking world. Max. 10 participants.',
    b1: 'Max. 10 people', b2: 'Casual topic', b4: '75 minutes', todosNiveles: 'All levels',
    sesion: 'session', sesiones: 'sessions', verDetalles: 'View details', sinCupos: 'Full', inscribirme: 'Enroll',
    vacio: 'There are no VideoForums available for this level.'
  }
}

function formatHora(horaStr) {
  const [h, m] = horaStr.split(':')
  const hora = parseInt(h)
  const ampm = hora >= 12 ? 'PM' : 'AM'
  const h12 = hora % 12 || 12
  return h12 + ':' + m + ' ' + ampm
}

const CATEGORIAS = {
  'general':                  { ic:'💬', color:'#6B7280' },
  'Medio ambiente y tecnologia': { ic:'🌱', color:'#22C55E' },
  'Viajes y turismo':          { ic:'✈️', color:'#3B82F6' },
  'Arte y cultura':            { ic:'🎨', color:'#8B5CF6' },
  'Gastronomia':               { ic:'🍽️', color:'#F59E0B' },
  'Musica y entretenimiento':  { ic:'🎵', color:'#EF4444' },
  'Deportes':                  { ic:'⚽', color:'#059669' },
  'Ciencia y tecnologia':      { ic:'🔬', color:'#1B3A8C' },
  'Historia y politica':       { ic:'📜', color:'#92400E' },
}

function getCategoriaInfo(categoria) {
  return CATEGORIAS[categoria] || CATEGORIAS['general']
}

export default function VideoForos({ usuario, idioma = 'es' }) {
  const t = TX[idioma] || TX.es
  const fecha_ = f => formatFecha(f, idioma)
  const nombreTema = tema => (idioma === 'en' && TEMAS_EN[tema]) ? TEMAS_EN[tema] : tema
  const [foros,       setForos]       = useState([])
  const [inscritos,   setInscritos]   = useState([])
  const [cargando,    setCargando]    = useState(true)
  const [procesando,  setProcesando]  = useState(null)
  const [mensaje,     setMensaje]     = useState(null)
  const [filtroNivel, setFiltroNivel] = useState('todos')
  const [foroDetalle, setForoDetalle] = useState(null)

  useEffect(() => { cargarDatos() }, [usuario])

  async function cargarDatos() {
    setCargando(true)
    try {
      const [forosRes, inscritosRes] = await Promise.all([
        axios.get(API + '/curriculo/videoforos'),
        usuario
          ? axios.get(API + '/curriculo/videoforos/mis-inscripciones/' + usuario.id).catch(() => ({ data: { datos: [] } }))
          : Promise.resolve({ data: { datos: [] } })
      ])
      setForos(forosRes.data.datos || [])
      setInscritos(inscritosRes.data.datos || [])
    } catch (err) { console.error(err) }
    finally { setCargando(false) }
  }

  async function inscribirse(foroId) {
    if (!usuario) return
    setProcesando(foroId)
    try {
      const res = await axios.post(API + '/curriculo/videoforos/' + foroId + '/inscribir', { usuario_id: usuario.id })
      setInscritos(prev => [...prev, foroId])
      setMensaje({ tipo:'ok', texto: res.data.mensaje })
      setTimeout(() => setMensaje(null), 4000)
      cargarDatos()
    } catch (err) {
      setMensaje({ tipo:'error', texto: err.response?.data?.error || t.errInscribir })
      setTimeout(() => setMensaje(null), 4000)
    } finally { setProcesando(null) }
  }

  async function cancelar(foroId) {
    if (!usuario) return
    setProcesando(foroId)
    try {
      await axios.delete(API + '/curriculo/videoforos/' + foroId + '/cancelar', { data: { usuario_id: usuario.id } })
      setInscritos(prev => prev.filter(id => id !== foroId))
      setMensaje({ tipo:'ok', texto: t.inscCancelada })
      setTimeout(() => setMensaje(null), 3000)
      cargarDatos()
    } catch (err) {
      setMensaje({ tipo:'error', texto: t.errCancelar })
      setTimeout(() => setMensaje(null), 3000)
    } finally { setProcesando(null) }
  }

  const niveles = ['todos', ...new Set(foros.map(f => f.nivel_id).filter(Boolean))]
  const forosFiltrados = filtroNivel === 'todos' ? foros : foros.filter(f => f.nivel_id === filtroNivel)
  const porFecha = forosFiltrados.reduce((acc, f) => {
    if (!acc[f.fecha]) acc[f.fecha] = []
    acc[f.fecha].push(f)
    return acc
  }, {})

  if (cargando) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:60, gap:16, color:'#6B7280' }}>
      <div style={{ width:32, height:32, border:'3px solid #E2E6F0', borderTopColor:'#7C3AED', borderRadius:'50%', animation:'spinner .8s linear infinite' }} />
      {t.cargando}
    </div>
  )

  // Vista detalle del foro
  if (foroDetalle) {
    const foro = foroDetalle
    const estaInscrito = inscritos.includes(foro.id)
    const sinCupos = foro.cupos_disponibles <= 0
    const catInfo = getCategoriaInfo(foro.tema)

    return (
      <div style={{ maxWidth:700, margin:'0 auto', animation:'fadeIn .3s ease both' }}>
        <button onClick={() => setForoDetalle(null)}
          style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, color:'#6B7280', fontFamily:'inherit', marginBottom:20 }}>
          {t.volver}
        </button>

        <div style={{ background:'linear-gradient(135deg,#4C1D95,#7C3AED)', borderRadius:16, padding:28, color:'#fff', marginBottom:24 }}>
          <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12, flexWrap:'wrap' }}>
            <span style={{ fontSize:28 }}>{catInfo.ic}</span>
            {foro.nivel_id && (
              <span style={{ background: COLORES_NIVEL[foro.nivel_id]||'#6B7280', color:'#fff', fontSize:10, fontWeight:800, padding:'2px 8px', borderRadius:999 }}>
                {foro.nivel_id}
              </span>
            )}
            <span style={{ fontSize:12, background:'rgba(255,255,255,0.15)', padding:'2px 10px', borderRadius:999 }}>
              VideoForo
            </span>
            {estaInscrito && <span style={{ fontSize:12, background:'#22C55E', padding:'2px 10px', borderRadius:999 }}>{t.inscrito}</span>}
          </div>
          <h1 style={{ fontSize:22, fontWeight:800, marginBottom:8 }}>{foro.titulo}</h1>
          <p style={{ fontSize:14, opacity:.85, lineHeight:1.6 }}>{foro.descripcion}</p>
          {foro.tema && (
            <div style={{ marginTop:12, background:'rgba(255,255,255,0.1)', borderRadius:8, padding:'8px 12px', fontSize:13 }}>
              {t.categoria} {nombreTema(foro.tema)}
            </div>
          )}
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:20 }}>
          <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:12, padding:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'#6B7280', marginBottom:8, textTransform:'uppercase' }}>{t.fechaHora}</div>
            <div style={{ fontSize:20, fontWeight:800, color:'#7C3AED' }}>{formatHora(foro.hora_inicio)}</div>
            <div style={{ fontSize:13, color:'#374151', marginTop:2 }}>{fecha_(foro.fecha)}</div>
            <div style={{ fontSize:12, color:'#9CA3AF', marginTop:4 }}>
              {t.duracion} {foro.duracion_min || 75} {t.minutos}
            </div>
            <div style={{ fontSize:12, color:'#9CA3AF' }}>
              {t.termina} {formatHora(foro.hora_fin)}
            </div>
          </div>

          <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:12, padding:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'#6B7280', marginBottom:8, textTransform:'uppercase' }}>{t.moderador}</div>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <div style={{ width:44, height:44, borderRadius:'50%', background:'#EDE9FE', display:'flex', alignItems:'center', justifyContent:'center', fontSize:20 }}>
                {foro.profesor_foto
                  ? <img src={foro.profesor_foto} alt={foro.profesor_nombre} style={{ width:44, height:44, borderRadius:'50%', objectFit:'cover' }} />
                  : '👤'}
              </div>
              <div>
                <div style={{ fontSize:14, fontWeight:700, color:'#1A1A2E' }}>{foro.profesor_nombre}</div>
                <div style={{ fontSize:12, color:'#6B7280' }}>{t.moderador}</div>
              </div>
            </div>
          </div>

          <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:12, padding:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'#6B7280', marginBottom:8, textTransform:'uppercase' }}>{t.cuposDisp}</div>
            <div style={{ fontSize:32, fontWeight:800, color: sinCupos ? '#EF4444' : foro.cupos_disponibles <= 3 ? '#F59E0B' : '#22C55E' }}>
              {foro.cupos_disponibles}
            </div>
            <div style={{ fontSize:12, color:'#6B7280' }}>{t.de} {foro.cupos_total} {t.participantesMax}</div>
            <div style={{ height:6, background:'#E2E6F0', borderRadius:999, marginTop:8, overflow:'hidden' }}>
              <div style={{ width: (foro.cupos_ocupados / foro.cupos_total * 100) + '%', height:'100%', borderRadius:999,
                background: sinCupos ? '#EF4444' : foro.cupos_disponibles <= 3 ? '#F59E0B' : '#7C3AED' }} />
            </div>
          </div>

          <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:12, padding:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'#6B7280', marginBottom:8, textTransform:'uppercase' }}>{t.plataforma}</div>
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              <span style={{ fontSize:24 }}>🎙</span>
              <div>
                <div style={{ fontSize:14, fontWeight:700 }}>Google Meet</div>
                <div style={{ fontSize:12, color:'#6B7280' }}>{t.videoconf}</div>
              </div>
            </div>
          </div>
        </div>

        {mensaje && (
          <div style={{ padding:'12px 16px', borderRadius:10, marginBottom:16, fontSize:14, fontWeight:600,
            background: mensaje.tipo==='ok' ? '#F0FDF4' : '#FEF2F2',
            color: mensaje.tipo==='ok' ? '#166634' : '#991B1B',
            border:'1px solid ' + (mensaje.tipo==='ok' ? '#22C55E' : '#EF4444') }}>
            {mensaje.tipo==='ok' ? '✅' : '❌'} {mensaje.texto}
          </div>
        )}

        <div style={{ display:'flex', gap:12 }}>
          {estaInscrito ? (
            <>
              {foro.link_meet && (
                <a href={foro.link_meet} target="_blank" rel="noopener noreferrer"
                  style={{ flex:1, padding:'12px', background:'#7C3AED', color:'#fff', border:'none', borderRadius:12, fontFamily:'inherit', fontSize:15, fontWeight:700, cursor:'pointer', textAlign:'center', textDecoration:'none', display:'block' }}>
                  {t.unirse}
                </a>
              )}
              <button onClick={() => cancelar(foro.id)} disabled={procesando === foro.id}
                style={{ padding:'12px 20px', background:'#FEF2F2', color:'#EF4444', border:'1.5px solid #EF4444', borderRadius:12, fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
                {t.cancelar}
              </button>
            </>
          ) : (
            <button onClick={() => inscribirse(foro.id)} disabled={sinCupos || procesando === foro.id}
              style={{ flex:1, padding:'12px', background: sinCupos ? '#E2E6F0' : '#7C3AED', color: sinCupos ? '#9CA3AF' : '#fff', border:'none', borderRadius:12, fontFamily:'inherit', fontSize:15, fontWeight:700, cursor: sinCupos ? 'not-allowed' : 'pointer' }}>
              {procesando === foro.id ? t.procesando : sinCupos ? t.sinCuposLargo : t.inscribirmeEste}
            </button>
          )}
        </div>
      </div>
    )
  }

  return (
    <div style={{ maxWidth:900, margin:'0 auto', animation:'fadeIn .3s ease both' }}>

      <div style={{ background:'linear-gradient(135deg,#4C1D95,#7C3AED)', borderRadius:16, padding:24, marginBottom:24, color:'#fff' }}>
        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:12 }}>
          <span style={{ fontSize:32 }}>🎙</span>
          <div>
            <h1 style={{ fontSize:22, fontWeight:800, marginBottom:2 }}>{t.titulo}</h1>
            <p style={{ fontSize:13, opacity:.8 }}>{t.subtitulo}</p>
          </div>
        </div>
        <div style={{ display:'flex', gap:20, flexWrap:'wrap' }}>
          {[
            { ic:'👥', label:t.b1 },
            { ic:'🎯', label:t.b2 },
            { ic:'🌎', label:'Google Meet' },
            { ic:'⏱', label:t.b4 },
          ].map((item,i) => (
            <div key={i} style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, opacity:.85 }}>
              <span>{item.ic}</span><span>{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {mensaje && (
        <div style={{ padding:'12px 16px', borderRadius:10, marginBottom:16, fontSize:14, fontWeight:600,
          background: mensaje.tipo==='ok' ? '#F0FDF4' : '#FEF2F2',
          color: mensaje.tipo==='ok' ? '#166634' : '#991B1B',
          border:'1px solid ' + (mensaje.tipo==='ok' ? '#22C55E' : '#EF4444') }}>
          {mensaje.tipo==='ok' ? '✅' : '❌'} {mensaje.texto}
        </div>
      )}

      <div style={{ display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' }}>
        {niveles.map(n => (
          <button key={n} onClick={() => setFiltroNivel(n)}
            style={{ padding:'6px 16px', borderRadius:999, border:'2px solid ' + (filtroNivel===n ? (COLORES_NIVEL[n]||'#7C3AED') : '#E2E6F0'),
              background: filtroNivel===n ? (COLORES_NIVEL[n]||'#7C3AED') : '#fff',
              color: filtroNivel===n ? '#fff' : '#374151',
              fontFamily:'inherit', fontSize:13, fontWeight:600, cursor:'pointer' }}>
            {n === 'todos' ? t.todosNiveles : n}
          </button>
        ))}
      </div>

      {Object.keys(porFecha).sort().map(fecha => (
        <div key={fecha} style={{ marginBottom:28 }}>
          <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:12 }}>
            <div style={{ background:'#7C3AED', color:'#fff', borderRadius:10, padding:'6px 14px', fontSize:13, fontWeight:700 }}>
              🗓 {fecha_(fecha)}
            </div>
            <div style={{ flex:1, height:1, background:'#E2E6F0' }} />
            <span style={{ fontSize:12, color:'#6B7280' }}>{porFecha[fecha].length} {porFecha[fecha].length>1 ? t.sesiones : t.sesion}</span>
          </div>

          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {porFecha[fecha].map(foro => {
              const estaInscrito = inscritos.includes(foro.id)
              const sinCupos = foro.cupos_disponibles <= 0
              const cargandoEste = procesando === foro.id
              const catInfo = getCategoriaInfo(foro.tema)

              return (
                <div key={foro.id}
                  style={{ background:'#fff', border:'1.5px solid ' + (estaInscrito ? '#7C3AED' : '#E2E6F0'),
                    borderRadius:14, padding:'18px 20px',
                    boxShadow: estaInscrito ? '0 0 0 3px rgba(124,58,237,0.1)' : 'none' }}>

                  <div style={{ display:'flex', alignItems:'flex-start', gap:16, flexWrap:'wrap' }}>

                    {/* Icono categoria */}
                    <div style={{ width:48, height:48, borderRadius:12, background:'#F5F3FF', display:'flex', alignItems:'center', justifyContent:'center', fontSize:24, flexShrink:0 }}>
                      {catInfo.ic}
                    </div>

                    {/* Info principal */}
                    <div style={{ flex:1, minWidth:200 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4, flexWrap:'wrap' }}>
                        {foro.nivel_id && (
                          <span style={{ background: COLORES_NIVEL[foro.nivel_id]||'#6B7280', color:'#fff', fontSize:10, fontWeight:800, padding:'2px 8px', borderRadius:999 }}>
                            {foro.nivel_id}
                          </span>
                        )}
                        {foro.tema && (
                          <span style={{ fontSize:11, background:'#F5F3FF', color:'#7C3AED', padding:'2px 8px', borderRadius:999, fontWeight:600 }}>
                            {nombreTema(foro.tema)}
                          </span>
                        )}
                        {estaInscrito && <span style={{ fontSize:11, color:'#7C3AED', fontWeight:700 }}>✓ {t.inscrito}</span>}
                      </div>
                      <div style={{ fontSize:15, fontWeight:700, color:'#1A1A2E', marginBottom:4 }}>{foro.titulo}</div>
                      {foro.descripcion && <div style={{ fontSize:12, color:'#6B7280' }}>{foro.descripcion}</div>}
                    </div>

                    {/* Hora y duracion */}
                    <div style={{ textAlign:'center', minWidth:80 }}>
                      <div style={{ fontSize:17, fontWeight:800, color:'#7C3AED' }}>{formatHora(foro.hora_inicio)}</div>
                      <div style={{ fontSize:11, color:'#6B7280' }}>{formatHora(foro.hora_fin)}</div>
                      <div style={{ fontSize:11, color:'#9CA3AF', marginTop:2 }}>{foro.duracion_min || 75} min</div>
                    </div>

                    {/* Moderador */}
                    <div style={{ textAlign:'center', minWidth:100 }}>
                      <div style={{ width:38, height:38, borderRadius:'50%', background:'#EDE9FE', display:'flex', alignItems:'center', justifyContent:'center', fontSize:16, margin:'0 auto 4px' }}>
                        {foro.profesor_foto
                          ? <img src={foro.profesor_foto} alt={foro.profesor_nombre} style={{ width:38, height:38, borderRadius:'50%', objectFit:'cover' }} />
                          : '👤'}
                      </div>
                      <div style={{ fontSize:11, fontWeight:600, color:'#1A1A2E' }}>{foro.profesor_nombre}</div>
                      <div style={{ fontSize:10, color:'#6B7280' }}>{t.moderador}</div>
                    </div>

                    {/* Cupos */}
                    <div style={{ textAlign:'center', minWidth:70 }}>
                      <div style={{ fontSize:22, fontWeight:800, color: sinCupos ? '#EF4444' : foro.cupos_disponibles <= 3 ? '#F59E0B' : '#22C55E' }}>
                        {foro.cupos_disponibles}
                      </div>
                      <div style={{ fontSize:11, color:'#6B7280' }}>{t.de} {foro.cupos_total}</div>
                      <div style={{ width:50, height:4, background:'#E2E6F0', borderRadius:999, margin:'4px auto 0', overflow:'hidden' }}>
                        <div style={{ width: (foro.cupos_ocupados/foro.cupos_total*100) + '%', height:'100%', borderRadius:999,
                          background: sinCupos ? '#EF4444' : foro.cupos_disponibles <= 3 ? '#F59E0B' : '#7C3AED' }} />
                      </div>
                    </div>

                    {/* Botones */}
                    <div style={{ minWidth:130, display:'flex', flexDirection:'column', gap:6 }}>
                      <button onClick={() => setForoDetalle(foro)}
                        style={{ width:'100%', padding:'7px 0', background:'#F5F3FF', color:'#7C3AED', border:'1px solid #DDD6FE', borderRadius:10, fontFamily:'inherit', fontSize:12, fontWeight:600, cursor:'pointer' }}>
                        {t.verDetalles}
                      </button>
                      {estaInscrito ? (
                        <button onClick={() => cancelar(foro.id)} disabled={cargandoEste}
                          style={{ width:'100%', padding:'7px 0', background:'#FEF2F2', color:'#EF4444', border:'1.5px solid #EF4444', borderRadius:10, fontFamily:'inherit', fontSize:12, fontWeight:600, cursor:'pointer' }}>
                          {cargandoEste ? '...' : t.cancelar}
                        </button>
                      ) : (
                        <button onClick={() => inscribirse(foro.id)} disabled={sinCupos || cargandoEste}
                          style={{ width:'100%', padding:'7px 0', background: sinCupos ? '#E2E6F0' : '#7C3AED', color: sinCupos ? '#9CA3AF' : '#fff', border:'none', borderRadius:10, fontFamily:'inherit', fontSize:12, fontWeight:600, cursor: sinCupos ? 'not-allowed' : 'pointer' }}>
                          {cargandoEste ? '...' : sinCupos ? t.sinCupos : t.inscribirme}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      ))}

      {forosFiltrados.length === 0 && (
        <div style={{ textAlign:'center', padding:60, color:'#6B7280' }}>
          <div style={{ fontSize:48, marginBottom:12 }}>🎙</div>
          <p style={{ fontSize:16 }}>{t.vacio}</p>
        </div>
      )}
    </div>
  )
}
